export default {"src":"/_next/static/media/rating.871a3e0c.svg","height":40,"width":84,"blurWidth":0,"blurHeight":0};